import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    this.inputTargets.forEach(input => {
      input.addEventListener('input', function (e) {
        let value = e.target.value.replace(/\s+/g, '').replace(',', '.');

        if (!isNaN(value) && value !== '') {
          e.target.value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        } else {
          e.target.value = '';
        }
      });
    });
  }
}
